import { format } from '@campaign-manager/core/lib/date';

import { isZeroDate } from '../../date/zero';
import ValuePlaceholder from '../ValuePlaceholder';

interface Props {
  date: Date | string | undefined;
  placeholder?: string;
}

export default function DateTimeValue(props: Props) {
  return <>{DateTimeValueString(props)}</>;
}

export function DateTimeValueString({ date, placeholder }: Props) {
  const isZero = !date || (!(date instanceof Date) && isZeroDate(date));

  if (isZero) {
    return <ValuePlaceholder placeholder={placeholder} />;
  }

  return format(date, true);
}
